import { gql } from '@apollo/client';

export const GET_TOKEN_TRANSACTIONS = gql`
  query GetTokenTransactions($tokenId: ID!) {
    tokenTransactions(tokenId: $tokenId) {
      id
      hidden
      tokenId
      transactionType
      price
      quantity
      timestamp
      fees
      feeQuantity
      cost
      proceeds
      notes
      currency
      failedStatus
      failedAt
    }
  }
`;

export const GET_PORTFOLIO_TRANSACTIONS = gql`
  query GetPortfolioTransactions($portfolioId: ID!, $limit: Int, $beforeDateTime: String) {
    transactions(portfolioId: $portfolioId, limit: $limit, beforeDateTime: $beforeDateTime) {
      total
      items {
        transaction {
          id
          hidden
          transactionType
          price
          scaledValues(portfolioId: $portfolioId) { price cost proceeds }
          quantity
          timestamp
          fees
          feeQuantity
          cost
          proceeds
          notes
          createdAt
          updatedAt
          currency
          locationId
          sourceLocationId
          destinationLocationId
          failedStatus
          failedAt
        }
        token {
          id
          ticker
          name
          isDelisted
          coingeckoSlug
          marketData {
            currentPrice
            priceChange24h
          }
        }
      }
    }
  }
`;

export const GET_TRANSACTION_YEARS = gql`
  query GetTransactionYears($portfolioId: ID!) {
    transactionYears(portfolioId: $portfolioId)
  }
`;
